import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Header from "../components/Header";
import BottomNav from "../components/BottomNav";
import Avatar from "../components/Avatar";
import TierBadge from "../components/TierBadge";
import FollowButton from "../components/FollowButton";
import { getPublicUser } from "../lib/api";
import { useAuth } from "../contexts/AuthContext";
import { Users } from "lucide-react";

export default function UserProfile() {
  const { id } = useParams();
  const { user: me } = useAuth();
  const [data, setData] = useState(null);

  useEffect(() => { getPublicUser(id).then(setData); }, [id]);

  if (!data) return (
    <div className="min-h-screen pb-safe"><Header title="Profile" />
      <div className="max-w-xl mx-auto px-4 pt-6 text-white/60">Loading…</div>
      <BottomNav />
    </div>
  );
  const u = data.user;
  const isSelf = me && me.user_id === u.user_id;

  return (
    <div className="min-h-screen pb-safe" data-testid="public-profile-page">
      <Header title="Profile" />
      <div className="max-w-xl mx-auto px-4 pt-4 space-y-4">
        <div className="glass-strong rounded-3xl p-5 relative overflow-hidden">
          <div aria-hidden className="pointer-events-none absolute -top-8 -right-8 w-40 h-40 rounded-full opacity-30" style={{ background: "radial-gradient(circle,#B026FF,transparent 70%)" }} />
          <div className="flex items-start gap-4">
            <Avatar name={u.name} category="default" size={72} rounded={18} />
            <div className="flex-1 min-w-0">
              <p className="font-display text-2xl font-bold truncate">{u.name}</p>
              <TierBadge tier={u.tier} />
              <p className="mt-1 text-xs text-white/50">{u.region}</p>
            </div>
            {!isSelf && <FollowButton userId={u.user_id} />}
          </div>
          <p className="mt-3 text-sm text-white/75">{u.bio || "—"}</p>
          <div className="mt-3 flex items-center gap-3 text-xs text-white/60">
            <span><b className="text-white">{(u.xp || 0).toLocaleString("en-IN")}</b> XP</span>
            <span className="inline-flex items-center gap-1"><Users className="w-3 h-3" /> {u.followers_count || 0} followers · {u.following_count || 0} following</span>
          </div>
          {u.fandoms?.length > 0 && (
            <div className="mt-3 flex flex-wrap gap-1.5">
              {u.fandoms.map(f => (
                <span key={f} className="chip" style={{ background: "#B026FF22", color: "#B026FF", border: "1px solid #B026FF55" }}>{f}</span>
              ))}
            </div>
          )}
        </div>

        <section>
          <h2 className="font-display text-xl font-bold mb-2">Top Lineups</h2>
          {(data.lineups || []).length === 0 && <p className="text-sm text-white/50 glass rounded-2xl p-4">No public lineups yet.</p>}
          <div className="space-y-2">
            {(data.lineups || []).slice(0, 8).map(l => (
              <div key={l.lineup_id} className="glass rounded-2xl p-3 flex items-center gap-3" data-testid={`user-lineup-${l.lineup_id}`}>
                <Avatar name={l.contest_id} category="default" size={36} rounded={10} showSymbol={false} />
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-semibold truncate">Lineup · {new Date(l.created_at).toLocaleDateString()}</p>
                  <p className="text-[11px] text-white/50">{l.picks?.length || 6} picks</p>
                </div>
                <span className="font-mono-brand text-sm neon-up">{Math.round(l.points || 0)} pts</span>
              </div>
            ))}
          </div>
        </section>

        <div className="h-10" />
      </div>
      <BottomNav />
    </div>
  );
}
